





































import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

import CrossSellProduct from '@plugin/Common/components/cross-sell/CrossSellProduct.vue'
import { CrossSellProductInterface } from '@plugin/Common/interfaces/cross-sell/entities/cross-sell-product.interface'

@Component({
  components: {
    CrossSellProduct,
  },
})
export default class CrossSellProductAddedDialogComponent extends Vue {
  @Prop({ type: String })
  public cancelButtonLabel!: string

  @Prop({ type: Boolean, default: false })
  public isOpen!: boolean

  @Prop({ required: true })
  public product!: CrossSellProductInterface

  @Prop({ required: true })
  public records!: CrossSellProductInterface[]

  @Prop({ type: String })
  public title!: string

  @Emit()
  closeDialog(): void {
    return
  }

  get modalAttachmentNode(): HTMLElement {
    return document.body
  }
}
